import axios from 'axios'

function cleanComma(value) {
  return value.replace(/,/g, '.')
}

function showError($element) {
  $element.html(R.strings.calculators.error)
}

// --- Carbon equivalent ---

function getEquivalentCarbonContent(
  carbon,
  manganese,
  chromium,
  molybdenum,
  vanadium,
  nickel,
  copper,
) {
  const dp = R.settings.calculators.decimalPlaces

  if (carbon >= 0.18) {
    // International Institute of Welding (I.I.W.) formula
    return (
      carbon +
      manganese / 6 +
      (chromium + molybdenum + vanadium) / 5 +
      (copper + nickel) / 15
    ).toFixed(dp)
  } else {
    // Ito-Bessyo formula for carbon < 0.18%
    return (
      carbon +
      (manganese + copper + chromium) / 20 +
      nickel / 60 +
      molybdenum / 15 +
      vanadium / 10
    ).toFixed(dp)
  }
}

$('#carbon-equivalent').on('submit', function (e) {
  e.preventDefault()

  const $form = $(this)
  const $result = $form.find('.result')
  let hasError = false

  $form.find('input').each(function () {
    const value = cleanComma($(this).val())
    if (value && isNaN(value)) {
      showError($result)
      hasError = true
      return false
    }
  })

  if (hasError) return

  const carbon = Number(cleanComma($form.find('#carbon').val()))
  const manganese = Number(cleanComma($form.find('#manganese').val()))
  const chromium = Number(cleanComma($form.find('#chromium').val()))
  const molybdenum = Number(cleanComma($form.find('#molybdenum').val()))
  const vanadium = Number(cleanComma($form.find('#vanadium').val()))
  const nickel = Number(cleanComma($form.find('#nickel').val()))
  const copper = Number(cleanComma($form.find('#copper').val()))

  if (carbon > 0) {
    $result.html(
      getEquivalentCarbonContent(carbon, manganese, chromium, molybdenum, vanadium, nickel, copper),
    )
  } else {
    showError($result)
  }
})

// --- Weight per meter ---

$('#weight-per-meter').on('submit', async function (e) {
  e.preventDefault()

  const $form = $(this)
  const $result = $form.find('.result')
  const $resultTotal = $form.find('.result-total')

  try {
    const response = await axios.post(`${settings.siteAddress}/api/weight-per-meter.php`, {
      outsideDiameter: cleanComma($form.find('#outside-diameter').val()),
      insideDiameter: cleanComma($form.find('#inside-diameter').val()),
      thickness: cleanComma($form.find('#thickness').val()),
      group: $form.find('#group').val(),
      quantity: cleanComma($form.find('#quantity').val()),
      special: $form.find('#special').val(),
    })

    const data = response.data
    const unitWeight = data.KM
    const totalWeight = data.KG

    $result.html(unitWeight + ' ' + R.strings.calculators.kgUnit)
    $resultTotal.html(
      (totalWeight && totalWeight !== '0.000' ? totalWeight : unitWeight) +
        ' ' +
        R.strings.calculators.kg,
    )
  } catch (e) {
    showError($result.add($resultTotal))
  }
})

$('#shipping-date').on('submit', async function (e) {
  e.preventDefault()

  const $form = $(this)
  const $result = $form.find('.result')

  const zip = $form.find('#zip').val()
  const deliveryType = $form.find('#delivery-type').val()

  if (!zip || isNaN(zip) || zip < 999) {
    showError($result)
    return
  }

  if (!deliveryType) {
    showError($result)
    return
  }

  try {
    const response = await axios.post(`${settings.siteAddress}/api/shipping-date.php`, {
      zip: zip,
      desiredDeliveryDate: $form.find('#desired-delivery-date').val().replace(/-/g, ''),
      deliveryType: deliveryType,
    })

    const timestamp = response.data

    if (!timestamp || isNaN(timestamp) || timestamp < 1) {
      showError($result)
      return
    }

    const date = new Date(timestamp * 1000)
    const dateString =
      R.strings.dayNamesMin[date.getDay()] +
      ', ' +
      date.getDate() +
      '. ' +
      R.strings.monthNames[date.getMonth()] +
      ' ' +
      date.getFullYear()

    $result.html(dateString)
  } catch (e) {
    showError($result)
  }
})
